// config/routes.ts - 最もシンプルな設定

import { PAGE_PATHS } from "./urls";

/**
 * 認証不要ルートのリスト
 * ここに含まれないすべてのルートは認証が必要
 */
export const PUBLIC_ROUTES = [
  //   PAGE_PATHS.CALLBACK,
  PAGE_PATHS.LOGOUT,
  PAGE_PATHS.TEST_LOGIN, // テストログイン（開発環境のみ）
  PAGE_PATHS.PUBLIC_EVENT,
  PAGE_PATHS.PUBLIC_STUDY_GROUP,
  PAGE_PATHS.STUDY_GROUP_INVITE,
  PAGE_PATHS.NOT_FOUND,
  // 今後追加する認証不要ルートをここに追加
] as const;

/**
 * パスが認証不要ルートかチェック
 * 子パス(/callback/success など)も含む
 */
export const isPublicRoute = (pathname: string): boolean => {
  return PUBLIC_ROUTES.some((route) => pathname.startsWith(route));
};

/**
 * パスが認証必要ルートかチェック
 * 認証不要ルート以外はすべて認証必要
 */
export const isProtectedRoute = (pathname: string): boolean => {
  return !isPublicRoute(pathname);
};

/**
 * 認証不要ルートの一覧を取得
 */
export const getPublicRoutes = (): readonly string[] => {
  return PUBLIC_ROUTES;
};
